import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router';
import './App.css';
import Navbar from './Components/Navbar';
import Interview_link from './Pages/Interview_link';
import Interview_Questions from './Pages/Interview_Questions';
import PrivateRoute from './PrivateRoute';
import Score from './Pages/Score';
import { useDispatch } from 'react-redux';
import { resetUserStateAfterExpiry } from './Redux/UserSlice';
import useBrowserCheck, { PopupModal } from './Components/UseBrowserCheck';

function PageTracker() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(resetUserStateAfterExpiry());
    }, 60 * 1000); // check every 60 seconds

    return () => clearInterval(interval);
  }, [dispatch]);

  return null;
}

function App() {
  const isUnsupported = useBrowserCheck();
  return (
    <>
      {isUnsupported && (
        <PopupModal
          message="This website is only supported on Chrome, Safari, Firefox, and Edge. Please switch to one of these browsers to continue."
        />
      )}
      {!isUnsupported && (
        <BrowserRouter>
          <Navbar />
          <PageTracker />
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Interview_link />
                </PrivateRoute>
              }
            />
            <Route path="/interview-link" element={<Interview_link />} />
            <Route
              path="/interview-questions"
              element={
                <PrivateRoute>
                  {/* <Interview_Questions /> */}
                  <Interview_Questions />
                </PrivateRoute>
              }
            />
            <Route
              path="/interview-score"
              element={
                // <PrivateRoute>
                <Score />
                // </PrivateRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
